<template>
  <IMenu width="176" aria-label="メニュー">
    <template #link>
      <i class="icon-dots-horizontal" :class="$style.button" />
    </template>
    <template #menu>
      <p v-if="statementForNote" :class="$style.statementForNote"><a :href="statementForNote">特定商法取引情報</a></p>
      <p :class="$style.openingDate">開店日：{{ openingDate }}</p>
    </template>
  </IMenu>
</template>

<script setup lang="ts">
import IMenu from '@/js/components/molecules/IMenu.vue';

defineProps<{
  statementForNote: string;
  openingDate: string;
}>();
</script>

<style module lang="scss">
.button {
  border: 1px solid $gray300;
  border-radius: 50%;
  color: #4b4b4b;
  font-size: 32px;
  position: relative;
  top: 2px;

  &:hover {
    opacity: 0.8;
  }
}

.statementForNote {
  margin-bottom: 10px;

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}

.openingDate {
  color: #b9b9b9;
}
</style>
